import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useToasts } from 'react-toast-notifications'

import CreditCard from '../../../../components/ReusableComponents/CreditCard/index'
import styles from './EditCreditCardDialog.module.scss'

const EditCreditCardDialog = ({ creditCardInfo, onSubmit, onClose }) => {
  const [expirationDate, setExpirationDate] = useState('')
  const [CVC, setCVC] = useState('')

  const [isExpirationDateValid, setIsExpirationDateValid] = useState(false)
  const [isCVCValid, setIsCVCValid] = useState(false)

  const { addToast } = useToasts()

  useEffect(() => {
    if (
      expirationDate.match(/\d{2}\/\d{2}/) &&
      Number(expirationDate.slice(-2)) >= Number(moment().format('YY'))
    ) {
      setIsExpirationDateValid(true)
    } else {
      setIsExpirationDateValid(false)
    }

    if (CVC.length < 3) {
      setIsCVCValid(false)
    } else {
      setIsCVCValid(true)
    }
  }, [expirationDate, CVC])

  function formatExpirationDate(expirationDate) {
    const [month, year] = expirationDate.split('/')

    return `${`${month}`.length === 1 ? `0${month}` : `${month}`}/${year.slice(-2)}`
  }

  function handleSubmit() {
    if (!isExpirationDateValid) {
      addToast(`Please enter a valid expiration date`, {
        appearance: 'error',
        autoDismiss: true
      })
    }

    if (!isCVCValid) {
      addToast(`Please enter a valid CVC`, {
        appearance: 'error',
        autoDismiss: true
      })
    }

    if (isExpirationDateValid && isCVCValid) {
      const [month, year] = expirationDate.split('/')

      onSubmit({ cvv: CVC, expirationMonth: month, expirationYear: `20${year}` })
    }
  }

  function formatExpirationDateFromInputValue(string) {
    return string
      .replace(
        /[^0-9]/g,
        '' // To allow only numbers
      )
      .replace(
        /^([2-9])$/g,
        '0$1' // To handle 3 > 03
      )
      .replace(
        /^(1{1})([3-9]{1})$/g,
        '0$1/$2' // 13 > 01/3
      )
      .replace(
        /^0{1,}/g,
        '0' // To handle 00 > 0
      )
      .replace(
        /^([0-1]{1}[0-9]{1})([0-9]{1,2}).*/g,
        '$1/$2' // To handle 113 > 11/3
      )
  }

  return (
    <ConfirmationDialog
      title="Update credit card"
      theme="blacklist"
      maxWidth={800}
      positiveMessage="Update"
      negativeMessage="Cancel"
      onConfirm={handleSubmit}
      onClose={onClose}
    >
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.cardHolder}>
            <CreditCard
              holder={creditCardInfo.accountHolderName}
              last4={creditCardInfo.last4}
              network={creditCardInfo.network.toLowerCase()}
              expDate={
                expirationDate || formatExpirationDate(creditCardInfo.expirationDate)
              }
            />
          </div>
          <div className={styles.formContent}>
            <div className={styles.creditCardForm}>
              <div className={styles.formRow}>
                <TextInput
                  label="Cardholder's name"
                  value={creditCardInfo.accountHolderName}
                  maxLength={50}
                  disabled
                />
              </div>
              <div className={styles.formRow}>
                <div>
                  <TextInput
                    label="Exp date"
                    onChangeValue={value =>
                      setExpirationDate(formatExpirationDateFromInputValue(value))
                    }
                    value={expirationDate}
                    valid={expirationDate ? isExpirationDateValid : null}
                  />
                </div>
                <div>
                  <TextInput
                    label="CVC"
                    name="cvc"
                    value={CVC}
                    onChangeValue={setCVC}
                    maxLength="4"
                    valid={CVC ? isCVCValid : null}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.legalText}>
          By supplying this information and completing the transaction, I hereby authorize
          Directful Inc. to initiate a debit against the above credit card, and to charge
          the same to such credit card. I acknowledge that my Account must comply with the
          provisions of U.S. law.
        </div>
      </div>
    </ConfirmationDialog>
  )
}

export default EditCreditCardDialog
